import {defineStore} from "pinia";
import {Account} from "@/scripts/types/account";
import {getAccount} from "@/scripts/api/account";

interface State {
    account: Account;
}

export const useAccount = defineStore('useAccount', {
    state: (): State => ({
        account: {} as Account,
    }),
    actions: {
        async getAccount() {
            try {
                this.account = await getAccount();
            } catch (error: any) {
            }
        },
    }
});